<template lang="pug">
.v-field-text.field-text
	template(v-if="field.type === 'textarea'")
		label.field-label(v-if="field.label" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		textarea.field-input(:inputmode="field.inputmode"
			:disabled="field.disabled"
			:placeholder="computedPlaceholder"
			v-model="localValue"
			@input="handleInput"
			:id="uniqueId")
	template(v-else-if="field.mask")
		label.field-label(v-if="field.label" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		input.field-input(:type="computedType"
			:inputmode="field.inputmode"
			:disabled="field.disabled"
			:placeholder="computedPlaceholder"
			:value="localValue"
			:id="uniqueId"
			v-imask="computedMask"
			@accept="onAccept"
			@complete="onComplete")
	template(v-else-if="field.selectField")
		label.field-label.field-label--center(v-if="field.label" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		.field-tel__wrap
			.field-tel__select(v-if="field.masks && field.selectField")
				v-field-select(:field="field.selectField" :model-value="[selectLocalValue]" @update:model-value="handleInputSelect" :show-clean="false")
			input.field-input(:type="computedType"
				:inputmode="field.inputmode"
				:disabled="field.disabled"
				:placeholder="computedPlaceholder"
				:value="localValue"
				:id="uniqueId"
				v-imask="computedMasks"
				@accept="onAccept"
				@complete="onComplete")
	template(v-else)
		label.field-label(v-if="field.label" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		input.field-input(
			:type="computedType"
			:inputmode="field.inputmode"
			:disabled="field.disabled"
			:placeholder="computedPlaceholder"
			v-model="localValue"
			@input="handleInput"
			@keyup="handleKeyup"
			@focus="emitFocus"
			@blur="emitBlur"
			:id="uniqueId")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [String, Number, Object],
			default: null
		}
	},

	emits: [
		'update:model-value',
		'focus',
		'blur'
	],

	data() {
		return {
			localValue: null,
			savedValue: null,
			unmaskedValue: null,
			fullUnmaskedValueLength: 0,
			selectLocalValue: null,
			uniqueId: uniqueId('field-text_')
		};
	},

	created() {
		if (this.field.selectField) {
			this.selectLocalValue = this.field.selectField.value[0];
		}
	},

	computed: {
		computedPlaceholder() {
			return `${this.field.placeholder}${this.field.required ? '*' : ''}`
		},

		computedMask() {
			if (this.field.mask.mask === 'Number') {
				return {
					'mask': Number,
					'scale': 3,
					'min': this.field.mask['min'],
					'max': this.field.mask['max'],
					'thousandsSeparator': this.field.mask['thousandsSeparator'],
					'radix': this.field.mask['radix'],
					'mapToRadix': this.field.mask['mapToRadix']
				};
			} else {
				return this.field.mask;
			}
		},

		computedMasks() {
			return {
				"mask": this.field.masks?.find(item => item.id === this.selectLocalValue)?.mask || {},
				"lazy": true
			}
		},

		computedType() {
			if (!this.field.type || this.field.type == 'number') {
				return 'text';
			}
			return this.field.type;
		},

		isFieldNumeric() {
			return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				if (this.isFieldNumeric && this.modelValue) {
					this.localValue = this.savedValue = this.modelValue.toString().replace('.', ',');
				} else if (typeof this.modelValue === 'object' && this.modelValue?.account !== undefined) {
					this.localValue = this.savedValue = this.modelValue.account;
				} else {
					this.localValue = this.savedValue = this.modelValue;
				}
			}
		}
	},

	methods: {
		emitFocus(e) {
			this.$emit('focus', e);
		},

		emitBlur(e) {
			this.$emit('blur', e);
		},

		onAccept(e) {
			if (e.detail.unmaskedValue.length !== this.fullUnmaskedValueLength) {
				this.handleInputTel(e);
			}
		},

		onComplete(e) {
			this.handleInputTel(e);
		},

		handleKeyup() {
			if (this.isFieldNumeric && this.savedValue) {
				this.localValue = this.savedValue.replace('.', ',');
			}
		},

		handleInputTel(e) {
			this.unmaskedValue = e.detail.unmaskedValue;
			this.fullUnmaskedValueLength = this.unmaskedValue.length;
			let value = this.unmaskedValue;
			if (this.selectLocalValue) {
				value = {
					'code': this.selectLocalValue,
					'account': this.unmaskedValue
				}
			}
			this.$emit('update:model-value', value);
		},

		handleInputSelect(value) {
			this.selectLocalValue = value[0];
		},

		handleInput() {
			if (this.isFieldNumeric) {
				if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
					this.savedValue = this.localValue;
				} else {
					this.localValue = this.savedValue;
				}
				this.$emit('update:model-value', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue);
			} else {
				this.$emit('update:model-value', this.localValue);
			}
		}
	}
};
</script>
